var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" WAIVER ")]),_c('h4',[_vm._v(" An intentional relinquishment of medical coverage for a particular medical condition for the entire duration of the membership. ")])])
}]

export { render, staticRenderFns }